module.exports = __webpack_public_path__ + "static/turtle-creek-house04-f833b631fe1d72d09b482c14b10cf43e.jpg";